import messages from '../../../../locale/messages'
import moment from 'moment';
import { toPlacementList } from '../../../../helpers/contentPagePlacement';

const validate = values => {

    const errors = {}
  
    if (!values.pageBanner) {
      errors.pageBanner = messages.required;
    }

    if (!values.metaTitle) {
      errors.metaTitle =  messages.required;
    } else if (values.metaTitle.trim() == "") {
        errors.metaTitle =  messages.required;
    }
  
    if (!values.metaDescription) {
      errors.metaDescription =  messages.required;
    } else if (values.metaDescription.trim() == "") {
        errors.metaDescription =  messages.required;
    }
  
    if (!values.pageUrl) {
      errors.pageUrl =  messages.required;
    } else if (values.pageUrl.trim() == "") {
        errors.pageUrl =  messages.required;
    }
    else {
      var slashCount = (values.pageUrl.match(/\//g) || []).length;
      var questionCount = (values.pageUrl.match(/\?/g) || []).length;
      var andCount = (values.pageUrl.match(/\&/g) || []).length;
      if (slashCount >= 1 || questionCount >= 1 || andCount >= 1) {
        errors.pageUrl = messages.invalidUrl.defaultMessage;
      }
    }
  
    if (!values.pageTitle) {
      errors.pageTitle =  messages.required;
    } else if (values.pageTitle.trim() == "") {
        errors.pageTitle =  messages.required;
    }
  
    if (!values.content) {
      errors.content =  messages.required;
    } else if (values.content.trim() == "") {
        errors.content =  messages.required;
    }

    if (!values.placement || toPlacementList(values.placement).length < 1) {
      errors.placement = messages.required;
    }

    if (values.startDate && values.endDate) {
      if (!moment(values.endDate).isAfter(moment(values.startDate))) {
        errors.endDate = 'End date must be greater than start date';
      }
    }

    return errors;
  }
  
  export default validate;
  